import React from "react";

import { Dropdown } from "./clearsense-ui/components";
import { MenuHorizontal } from "./clearsense-ui/icons";
import PermissibleWrapper from "./PermissibleWrapper";

const ActionDropdown = ({ editProps, deleteProps, userPermissions = [] }) => (
  <div className="flex justify-center" data-testid="action-dropdown-button">
    <Dropdown
      buttonStyle="text"
      strategy="fixed"
      buttonProps={{ icon: MenuHorizontal, iconSize: 20 }}
      ulProps={{ className: "cs-ui-dropdown__popup p-0 m-0" }}
      data-cy="action-dropdown-button"
    >
      <PermissibleWrapper
        currentPermissions={userPermissions}
        acceptablePermissions="update"
      >
        {editProps ? (
          <li className="px-4 py-2" {...editProps} data-testid="edit-button">
            Edit
          </li>
        ) : (
          <> </>
        )}
      </PermissibleWrapper>
      <PermissibleWrapper
        currentPermissions={userPermissions}
        acceptablePermissions="destroy"
      >
        {deleteProps ? (
          <li
            className="px-4 py-2"
            {...deleteProps}
            data-testid="delete-button"
          >
            Delete
          </li>
        ) : (
          <> </>
        )}
      </PermissibleWrapper>
    </Dropdown>
  </div>
);

export default ActionDropdown;
